import React, {useEffect, useState} from 'react';
import {Formik} from 'formik';
import * as Yup from 'yup';
import {TextField, FormHelperText, Button, MenuItem} from '@material-ui/core';
import GuiAutoComplete from '../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../components/FormComponents/GuiTextField';
import {useDispatch, useSelector} from 'react-redux';
import {
  fetchAllCorporateName,
  getServiceClientDetails,
  postCorporateInfo,
  resetToast,
} from '../../redux/reducers/clientMangement/Organizaation';
import reusableInputStyles from '../../components/InputStyles';
import PageLoader from '../../components/PageLoader';
import {submissionStart} from '../../redux/reducers/CommonActions/commonActions';
const CorporateForm = ({
  setOpen = () => {},
  edit,
  tableData,
  siteTableData,
  handleDirty,
  organizationAccess,
}) => {
  const [codePopover, setCodePopover] = useState(false);
  const [reportCodesData, setReportCodesData] = useState();
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const {
    corporateAPIdata,
  } = useSelector(({organization}) => organization);
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const {
    status,
    isLoading,
    successMsg,
    errorMsg,
    dropDownData,
    serviceClientInfo: corporateInfo,
    allCorporateNames,
  } = useSelector(({organization}) => organization);
  const seedOnlyOptions = [
    {key: 'Y', value: 'Yes'},
    {key: 'N', value: 'No'},
  ];
  const authorityOptions = [
    {key: 'Y', value: 'Yes'},
    {key: 'N', value: 'No'},
  ];

  const corporateNameData = (data) => {
    const clientData =
      tableData?.length > 0 ? allCorporateNames : siteTableData?.length > 0 ? editTableData : [];
    return clientData;
  };

  const checkCorporateNameExist = (value) => {
    if (
      corporateNameData(corporateAPIdata) &&
      corporateNameData(corporateAPIdata)?.length > 0 &&
      value
    ) {
      const titleData = [];
      corporateNameData(corporateAPIdata)?.filter((i) => {
        if (
          i?.corporateName?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'Y' 
        ) {
          titleData.push(i);
        }
      });
      return titleData.length > 0;
    } else {
      return false;
    }
  };
  const checkGroupCodeAlreadyExist = (value) => {
    if (
      corporateNameData(allCorporateNames) &&
      corporateNameData(allCorporateNames)?.length > 0 &&
      value
    ) {
      const ar = [];
      corporateNameData(allCorporateNames)?.filter((i) => {
        if (
          i?.corporateName?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'N'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const getCompanyCodesData = () => {
    if (corporateAPIdata && corporateAPIdata?.length > 0) {
      return corporateAPIdata?.filter((i) =>
        i?.corporateName?.toLowerCase()?.trim().startsWith(reportCodesData?.toLowerCase()?.trim()),
      );
    } else {
      return [];
    }
  };

  const validationSchema = Yup.object().shape({
    agregateLegalCollection: Yup.mixed().test(
      'agregateLegalCollection',
      'Aggregation Legal Collection is required',
      (value) => {
        if (!value?.value) {
          return false;
        } else {
          return true;
        }
      },
    ),
    allowPaymentAgregation: Yup.mixed().test(
      'allowPaymentAgregation',
      'Allow Payment Aggregation is required',
      (value) => {
        if (!value?.value) {
          return false;
        } else {
          return true;
        }
      },
    ),
    corporateName: Yup.string()
      .required('Corporate Name is required')
      .test(
        'corporateName',
        'Corporate Name  already exists',
        (value) => !checkCorporateNameExist(value),
      )
      .trim()
      .test(
        'corporateName',
        'Corporate Name has already been used in the past',
        (value) => !checkGroupCodeAlreadyExist(value),
      ),
    invoiceAtThisLevel: Yup.mixed().test('invoiceAtThisLevel', 'Invoice is required', (value) => {
      if (!value?.value) {
        return false;
      } else {
        return true;
      }
    }),
    authorityToSue: Yup.mixed().test('authorityToSue', 'Authority to Sue is required', (value) => {
      if (!value?.value) {
        return false;
      } else {
        return true;
      }
    }),
    invoiceType: Yup.mixed()
      .test('invoiceType', 'Invoice Type is Required', (value, valid) => {
        const value1 = valid?.parent;
        if (!value?.valueCode && value1?.invoiceAtThisLevel?.value === 'Yes') {
          return false;
        } else {
          return true;
        }
      })
      .nullable(),
  });

  useEffect(() => {
    if (status === 200) {
      setOpen(false);
    }
  }, [status]);

  useEffect(() => {
    if (successMsg || errorMsg) {
      setTimeout(() => {
        dispatch(resetToast());
      }, 3000);
    }
  }, [successMsg, errorMsg]);

  useEffect(() => {
    dispatch(fetchAllCorporateName());
  }, []);

  useEffect(() => {
    if (successMsg && corporateInfo?.corporateId) {
      dispatch(getServiceClientDetails(corporateInfo?.corporateId, 'Corporate'));
    }
  }, [successMsg, corporateInfo?.corporateId]);
  const editTableData =
    allCorporateNames?.length > 0 ?
      allCorporateNames?.filter(
        (el) =>
          el.corporateName?.toLowerCase()?.trim() !==
            corporateInfo?.corporateName?.toLowerCase()?.trim(),
      ) :
      [];

  const getOption = (data, property, value) => {
    if (!data || data?.length === 0) {
      return {};
    }
    const obj = data?.find((item) => item[property] === value);
    return obj ? obj : {};
  };

  const initialVal = {
    agregateLegalCollection:
      getOption(seedOnlyOptions, 'value', corporateInfo?.agregateLegalCollection) || '',
    allowPaymentAgregation:
      getOption(seedOnlyOptions, 'value', corporateInfo?.allowPaymentAgregation) || '',
    clientPrefix: corporateInfo?.clientPrefix || '',
    corporateName: corporateInfo?.corporateName || '',
    invoiceAtThisLevel: corporateInfo?.invoiceAtThisLevel ?
      getOption(seedOnlyOptions, 'value', corporateInfo?.invoiceAtThisLevel) :
      {key: 'Y', value: 'Yes'},
    invoiceType: getOption(dropDownData?.INVOICE_TYPE, 'value', corporateInfo?.invoiceType) || '',
    authorityToSue: corporateInfo?.authorityToSue ?
      getOption(authorityOptions, 'value', corporateInfo?.authorityToSue) :
      {key: 'N', value: 'No'},
    corporateId: '',
  };

  const handleSubmit = (values) => {
    if (values) {
      dispatch(submissionStart());
      const data = {
        agregateLegalCollection: values?.agregateLegalCollection?.value ?
          values?.agregateLegalCollection?.value :
          '',
        allowPaymentAgregation: values?.allowPaymentAgregation?.value ?
          values?.allowPaymentAgregation?.value :
          '',
        corporateId: corporateInfo?.corporateId || 0,
        corporateName: values?.corporateName ? values?.corporateName : '',
        invoiceAtThisLevel: values?.invoiceAtThisLevel?.value ?
          values?.invoiceAtThisLevel?.value :
          '',
        invoiceType:
          values?.invoiceAtThisLevel?.value === 'Yes' && values?.invoiceType?.value ?
            values?.invoiceType?.value :
            '',
        authorityToSue: values?.authorityToSue?.value ? values?.authorityToSue?.value : '',
      };
      dispatch(postCorporateInfo(data));
      setTimeout(() => {
        setOpen(false);
      }, 1500);
    }
    handleDirty(false, 'fixed');
  };
  window.onclick = function() {
    setCodePopover(false);
  };

  return (
    <>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialVal}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {(props) => {
          const {
            values,
            errors,
            touched,
            handleBlur,
            handleSubmit,
            setFieldValue,
            resetForm,
            dirty,
          } = props;
          handleDirty && handleDirty(dirty);
          return (
            <div className="col-12">
              <div className="new-standard-textfields">
                <form autoComplete="off" noValidate onSubmit={handleSubmit}>
                  <div className="form-row global-field-textfields ">
                    <div className="col-sm-8 col-md-6 col-xl-4 form-group">
                      <TextField
                        // className={` ${classes.labelName} ${classes.inputLabel}`}
                        margin="dense"
                        variant="outlined"
                        placeholder={`Enter Corporate Name`}
                        label="Corporate Name"
                        // InputLabelProps={{
                        //   shrink: true,
                        // }}
                        name="corporateName"
                        required
                        value={values?.corporateName}
                        onChange={(e) => {
                          setFieldValue('corporateName', e.target.value);
                          if (e.target.value) {
                            setCodePopover(true);
                            setReportCodesData(e.target.value);
                          } else if (e.target.value === '') {
                            setCodePopover(false);
                          }
                        }}
                        onBlur={handleBlur}
                        fullWidth
                        touched={touched.corporateName}
                        error={Boolean(touched.corporateName && errors.corporateName)}
                      />
                      <FormHelperText>
                        {touched.corporateName && errors?.corporateName && errors.corporateName}
                      </FormHelperText>
                      <div className="windowcode-popover Add-trigger-group-popover">
                        {codePopover &&
                          getCompanyCodesData()?.map((data, i) => (
                            <MenuItem key={i}>{data?.corporateName}</MenuItem>
                          ))}
                      </div>
                    </div>

                    <div className={`col-sm-8 col-md-6 col-xl-4 form-group `}>
                      <GuiAutoComplete
                        classes={`${{
                          popper: classes.popper,
                          option: classes.option,
                        }}`}
                        name="agregateLegalCollection"
                        id="agregateLegalCollection"
                        size="small"
                        value={values.agregateLegalCollection}
                        options={seedOnlyOptions}
                        getOptionLabel={(option) => {
                          return option && option.value ?
                            option.valueCode === null ?
                              option.value :
                              option.value :
                            '';
                        }}
                        onChange={(e, value) => {
                          setFieldValue('agregateLegalCollection', value);
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              // className={` ${classes.labelName} ${classes.selectLabel}`}
                              {...params}
                              variant="outlined"
                              touched={touched.agregateLegalCollection}
                              error={
                                touched.agregateLegalCollection && errors.agregateLegalCollection
                              }
                              margin="dense"
                              required
                              // InputLabelProps={{
                              //   shrink: true,
                              // }}
                              label="Aggregation Legal Collection"
                              placeholder="Select Aggregation Legal Collection"
                            />
                          </div>
                        )}
                      />
                      <FormHelperText style={{color: 'red'}}>
                        {touched.agregateLegalCollection &&
                          errors?.agregateLegalCollection &&
                          errors.agregateLegalCollection}
                      </FormHelperText>
                    </div>
                    <div className="windowcode-popover Add-trigger-group-popover"></div>
                    <div className="col-sm-8 col-md-6 col-xl-4 form-group">
                      <GuiAutoComplete
                        classes={`${{
                          popper: classes.popper,
                          option: classes.option,
                        }}`}
                        name="allowPaymentAgregation"
                        id="allowPaymentAgregation"
                        size="small"
                        options={seedOnlyOptions}
                        required
                        value={values.allowPaymentAgregation}
                        getOptionLabel={(option) => {
                          return option && option.value;
                        }}
                        onChange={(e, value) => {
                          setFieldValue('allowPaymentAgregation', value);
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              {...params}
                              // className={` ${classes.labelName} ${classes.selectLabel}`}
                              variant="outlined"
                              margin="dense"
                              // InputLabelProps={{ shrink: true }}
                              label="Allow Payment Aggregation"
                              placeholder="Select Allow Payment Aggregation"
                              required
                              error={
                                touched.allowPaymentAgregation && errors.allowPaymentAgregation
                              }
                            />
                          </div>
                        )}
                      />
                      <FormHelperText>
                        {touched.allowPaymentAgregation &&
                          errors.allowPaymentAgregation &&
                          errors.allowPaymentAgregation}
                      </FormHelperText>
                    </div>
                    <div className="col-sm-8 col-md-6 col-xl-4 form-group">
                      <GuiAutoComplete
                        classes={`${{
                          popper: classes.popper,
                          option: classes.option,
                        }}`}
                        name="authorityToSue"
                        id="authorityToSue"
                        size="small"
                        options={authorityOptions}
                        required
                        value={values.authorityToSue}
                        getOptionLabel={(option) => {
                          return option && option.value;
                        }}
                        onChange={(e, value) => {
                          setFieldValue('authorityToSue', value);
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              {...params}
                              // className={` ${classes.labelName} ${classes.selectLabel}`}
                              variant="outlined"
                              margin="dense"
                              // InputLabelProps={{ shrink: true }}
                              label="Authority to Sue"
                              placeholder="Select Authority to Sue"
                              required
                              error={touched.authorityToSue && errors.authorityToSue}
                            />
                          </div>
                        )}
                      />
                      <FormHelperText>
                        {touched.authorityToSue && errors.authorityToSue && errors.authorityToSue}
                      </FormHelperText>
                    </div>
                    <div className="col-sm-8 col-md-6 col-xl-4 form-group">
                      <GuiAutoComplete
                        classes={`${{
                          popper: classes.popper,
                          option: classes.option,
                        }}`}
                        name="invoiceAtThisLevel"
                        id="invoiceAtThisLevel"
                        size="small"
                        options={seedOnlyOptions}
                        required
                        value={values.invoiceAtThisLevel}
                        getOptionLabel={(option) => {
                          return option && option.value;
                        }}
                        onChange={(e, value) => {
                          setFieldValue('invoiceAtThisLevel', value);
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              {...params}
                              // className={` ${classes.labelName} ${classes.selectLabel}`}
                              variant="outlined"
                              margin="dense"
                              // InputLabelProps={{ shrink: true }}
                              label="Invoice"
                              placeholder="Select Invoice"
                              required
                              error={touched.invoiceAtThisLevel && errors.invoiceAtThisLevel}
                            />
                          </div>
                        )}
                      />
                      <FormHelperText>
                        {touched.invoiceAtThisLevel &&
                          errors.invoiceAtThisLevel &&
                          errors.invoiceAtThisLevel}
                      </FormHelperText>
                    </div>
                    {values?.invoiceAtThisLevel?.value === 'Yes' && (
                      <div className="col-sm-8 col-md-6 col-xl-4 form-group">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="invoiceType"
                          id="invoiceType"
                          size="small"
                          options={dropDownData?.INVOICE_TYPE || []}
                          required
                          value={values.invoiceType}
                          getOptionLabel={(option) => {
                            return option && option.value ? option.value : '';
                          }}
                          onChange={(e, value) => {
                            setFieldValue('invoiceType', value);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                {...params}
                                // className={` ${classes.labelName} ${classes.selectLabel}`}
                                variant="outlined"
                                margin="dense"
                                // InputLabelProps={{ shrink: true }}
                                label="Invoice Type"
                                placeholder="Select Invoice Type"
                                required
                                error={touched.invoiceType && errors.invoiceType}
                              />
                            </div>
                          )}
                        />
                        <FormHelperText>
                          {touched.invoiceType && errors.invoiceType && errors.invoiceType}
                        </FormHelperText>
                      </div>
                    )}
                  </div>
                  <div className="button-spacing-mb">
                    <Button
                      variant="outlined"
                      className={`reset-btn mr-1 ${classes.buttonRoot}`}
                      onClick={() => {
                        resetForm();
                      }}
                    >
                      Reset
                    </Button>
                    <Button
                      variant="outlined"
                      type="submit"
                      disabled={(edit && !organizationAccess?.edit) || enabledSubmission}
                      className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                    >
                      Save
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          );
        }}
      </Formik>
      {isLoading && <PageLoader />}
    </>
  );
};

export default CorporateForm;
